export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M5,4V7H10.5V19H13.5V7H19V4H5Z\" /></svg>\n"